import React, { useState } from 'react';

const MerchantRegistrationOffersTest = () => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const testWithOffers = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const formData = new FormData();
      
      // Add basic merchant data
      formData.append('business_name', 'مطعم الشرق مع العروض');
      formData.append('legal_name', 'شركة الشرق للمطاعم');
      formData.append('cr_number', '1234567891');
      formData.append('contact_person', 'أحمد محمد');
      formData.append('phone', '+966501234568');
      formData.append('email', 'test2@example.com');
      formData.append('address', 'شارع الملك فهد، الرياض');
      formData.append('city', 'الرياض');
      formData.append('business_category', 'restaurant');

      // Add offers as individual form fields
      formData.append('offers[0][offer_title]', 'عرض الإفطار');
      formData.append('offers[0][offer_description]', 'خصم 20% على جميع وجبات الإفطار');
      formData.append('offers[0][discount_percentage]', '20');
      formData.append('offers[0][valid_from]', '2024-01-01');
      formData.append('offers[0][valid_until]', '2024-12-31');
      formData.append('offers[0][max_uses]', '100');
      formData.append('offers[0][min_wallet_balance]', '50');
      
      // Add products for the first offer
      formData.append('offers[0][products][0][product_name]', 'إفطار عربي');
      formData.append('offers[0][products][0][description]', 'إفطار تقليدي عربي');
      formData.append('offers[0][products][0][original_price]', '25.50');
      formData.append('offers[0][products][0][category]', 'طعام');
      formData.append('offers[0][products][0][stock_quantity]', '50');

      formData.append('offers[0][products][1][product_name]', 'قهوة عربية');
      formData.append('offers[0][products][1][description]', 'قهوة عربية أصيلة');
      formData.append('offers[0][products][1][original_price]', '15.00');
      formData.append('offers[0][products][1][category]', 'مشروبات');
      formData.append('offers[0][products][1][stock_quantity]', '100');

      // Add second offer
      formData.append('offers[1][offer_title]', 'عرض الغداء');
      formData.append('offers[1][offer_description]', 'خصم 15% على وجبات الغداء');
      formData.append('offers[1][discount_percentage]', '15');
      formData.append('offers[1][valid_from]', '2024-01-01');
      formData.append('offers[1][valid_until]', '2024-12-31');
      formData.append('offers[1][max_uses]', '200');
      formData.append('offers[1][min_wallet_balance]', '30');
      
      // Add products for the second offer
      formData.append('offers[1][products][0][product_name]', 'منسف لحم');
      formData.append('offers[1][products][0][description]', 'منسف لحم تقليدي');
      formData.append('offers[1][products][0][original_price]', '45.00');
      formData.append('offers[1][products][0][category]', 'طعام');
      formData.append('offers[1][products][0][stock_quantity]', '25');

      // Add gallery metadata
      formData.append('gallery_metadata', JSON.stringify([]));

      console.log('🧪 Testing API with offers:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await fetch('https://nodjswebhook.onrender.com/api/public/merchant-registration', {
        method: 'POST',
        body: formData
      });

      console.log('📡 Response status:', response.status);
      let result = await response.json();
      console.log('📡 Response data:', result);

      if (result.details && Array.isArray(result.details)) {
        console.log('❌ Validation errors:');
        result.details.forEach((detail, index) => {
          console.log(`${index + 1}. ${detail.path}: ${detail.msg} (value: ${detail.value})`);
        });
      }

      if (response.ok && result.success) {
        setResponse(result);
      } else {
        setError(result.error || 'Validation failed');
      }
    } catch (err) {
      console.error('Error testing API with offers:', err);
      setError('خطأ في الاتصال: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
      <h3 className="text-lg font-semibold mb-4 dark:text-gray-100">
        🎯 اختبار API مع العروض
      </h3>
      
      <button
        onClick={testWithOffers}
        disabled={loading}
        className="w-full px-4 py-2 bg-orange-600 text-white font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50"
      >
        {loading ? 'جاري الاختبار...' : 'اختبار API مع العروض والمنتجات'}
      </button>

      {response && (
        <div className="mt-4 p-3 bg-green-100 text-green-800 rounded-md dark:bg-green-900 dark:text-green-200">
          <p className="font-semibold">✅ نجح الاختبار:</p>
          <pre className="whitespace-pre-wrap text-sm">{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}

      {error && (
        <div className="mt-4 p-3 bg-red-100 text-red-800 rounded-md dark:bg-red-900 dark:text-red-200">
          <p className="font-semibold">❌ فشل الاختبار:</p>
          <pre className="whitespace-pre-wrap text-sm">{error}</pre>
        </div>
      )}
    </div>
  );
};

export default MerchantRegistrationOffersTest;
